import { ProjectStatus, statusInFastFilter } from 'api-client';

export type AccountInvestmentStatusFilter = {
  label: string;
  statuses: ProjectStatus[];
};

export const accountInvestmentStatusFilters: AccountInvestmentStatusFilter[] = [
  { label: 'ВСЕ СТАТУСЫ', statuses: [] },
  { label: 'АНОНСИРОВАН', statuses: statusInFastFilter['Анонсирован'] },
  { label: 'СБОР СРЕДСТВ', statuses: statusInFastFilter['Сбор средств'] },
  { label: 'ТЕКУЩИЙ', statuses: statusInFastFilter['Текущий'] },
  { label: 'ЗАВЕРШЕН', statuses: statusInFastFilter['Завершен'] },
  { label: 'ОТМЕНЕН', statuses: statusInFastFilter['Отменен'] },
];

export const areStatusFiltersEqual = (left: ProjectStatus[], right: ProjectStatus[]): boolean => {
  if (left.length !== right.length) {
    return false;
  }

  const leftSorted = [...left].sort();
  const rightSorted = [...right].sort();
  return leftSorted.every((status, index) => status === rightSorted[index]);
};
